import React from "react";
// import { withStyles } from "core/components/Styles";
const Title = ({text})=>(
	<div> 
		<h3>{text}</h3> 
	</div>
)
export default Title;